export default __webpack_public_path__ + "assets/img/icon-pw-hide@2x.55b87b7a8fe396468118eeefb10174eb.svg";